module.exports = __webpack_public_path__ + "static/img/img-2.0da8c60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-2.png
// module id = qbzf
// module chunks = 1